<template>
  <v-flex>
    <v-toolbar color="secondary" dense>
      <v-toolbar-title class="primarytext--text">Preautorizzate</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-title>
      <v-btn color="secondary" dark @click="newPreautorizzatoHandler">Aggiungi nuovo</v-btn>
      <!--      <v-btn color="error" dark @click="deletePreautorizzatoHandler">Elimina</v-btn>-->
    </v-card-title>
    <v-layout row wrap justify-space-around>
      <v-flex xs12 style="padding-left: 10px; padding-right: 10px">
        <v-data-iterator 
          :items="preautorizzati" 
          row
          wrap
          class="elevation-0"
          content-class="v-list--two-line"
          content-tag="v-list">
          <v-flex
            slot="no-data"
            align-self-center
            class="title font-weight-light grey--text pa-3 text-xs-center"
          >Non ci sono preutarizzate!</v-flex>
          <template slot="item" slot-scope="props">
            <v-list-tile>
              <v-list-tile-content>
                <div class="body-2 font-weight-medium">{{props.item.nominativo}}</div>
                <div>
                  <template v-for="(item,i) in creaIcone(props.item.categorie)">
                    <div :key="i" class="px-1" style="display: inline-grid;">
                      <v-tooltip bottom color="secondary">
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            size="14"
                            color="#01579b"
                            style="padding:0 5px 0 5px;"
                          >{{ item.icon }}</v-icon>
                        </template>
                        <span class="text-uppercase">{{item.descrizione}}</span>
                      </v-tooltip>
                    </div>
                  </template>
                </div>
                <v-divider class="my-1" style="width: 100%"></v-divider>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn icon flat @click="deletePreautorizzatoHandler(props.item)">
                  <v-icon color="error" >delete</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-data-iterator>
      </v-flex>
      <v-flex xs4 style="padding-right: 10px">
        <v-dialog v-model="dialog" max-width="500px" persistent>
          <v-card>
            <v-flex v-if=" newPre == true">
              <v-toolbar color="secondary" dense>
                <v-toolbar-title class="primarytext--text">Aggiungi nuovo Preautorizzato</v-toolbar-title>
                <v-btn
                  class="ma-0"
                  size="25"
                  absolute
                  flat
                  icon
                  right
                  dark
                  color="transparent"
                  @click="chiudiHandler"
                >
                  <v-icon size="30" color="#bfcbd9">close</v-icon>
                </v-btn>

                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-autocomplete
                  :items="allUsers"
                  item-text="nominativo"
                  item-value="login"
                  color="tree"
                  label="Nominativo"
                  clearable
                  v-model="newpreauto.login"
                  ></v-autocomplete>
                
                <v-select
                  :items="categorie"
                  item-text="descrizione"
                  item-value="id"
                  multiple
                  clearable
                  color="tree"
                  label="Categorie"
                  v-model="nomi_categorie"
                >
                  <template slot="selection" slot-scope="{ item, index }">
                    <v-icon small color="indigo" left>{{ item.icon }}</v-icon>
                  </template>
                  <template slot="item" slot-scope="{ item }">
                    <v-icon small color="grey" left>{{ item.icon }}</v-icon>
                    {{ item.descrizione.toUpperCase() }}
                  </template>
                </v-select>

                <v-btn color="secondary" dark @click="salvaPreautorizzatoHandler">Salva</v-btn>
              </v-card-text>
            </v-flex>
            <v-flex v-if=" deletePre == true">
              <v-toolbar color="secondary" dense>
                <v-toolbar-title class="primarytext--text">Elimina Preautorizzato</v-toolbar-title>
                <v-btn
                  class="ma-0"
                  size="25"
                  absolute
                  flat
                  icon
                  right
                  dark
                  color="transparent"
                  @click="chiudiHandler"
                >
                  <v-icon size="30" color="#bfcbd9">close</v-icon>
                </v-btn>

                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-card-title
                  style="font-size: 17px;"
                >Sei sicuro di voler eliminare {{eliminaPre.nominativo}}?</v-card-title>

                <v-btn
                  color="error"
                  dark
                  @click="eliminaPreautorizzatoHandler(eliminaPre.login)"
                >Elimina</v-btn>
              </v-card-text>
            </v-flex>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
export default {
  name: "preautorizzato",
  components: {},
  props: {},
  data() {
    return {
      dialog: false,

      newPre: false,
      deletePre: false,
      loader: false,
      newpreauto: {},
      date: null,
      eliminaPre: {},
      rowsPerPageItems: [3],
      pagination: {
        rowsPerPage: 2
      },
    };
  },
  computed: {
    nomi_categorie: {
      get() {
        return this.newpreauto.categorie
          ? this.newpreauto.categorie.split(",")
          : [];
      },
      set(val) {
        this.newpreauto.categorie = val.join(",");
      }
    },
    preautorizzati() {
      return this.$store.getters["gestione/preautorizzati"];
    },
    allUsers() {
      return this.$store.getters["gestione/allUsers"];
    },
    categorie() {
      return this.$store.getters.getPageData.categorieSpese;
    }
  },
  created() {
    this.$store.dispatch("gestione/getPreautorizzati");
    this.$store.dispatch("gestione/getAllUsers");
  },
  beforeCreate() {
    if (!this.$store.hasModule("gestione")) {
      this.$store.registerModule("gestione", GestioneAdmin);
    }
  },
  methods: {
    allowedMonths: val => val,
    getReport: function(e) {
      this.$store.dispatch("gestione/getMensile", { data: this.date });
    },
    newPreautorizzatoHandler() {
      this.deletePre = false;
      this.dialog = true;
      this.newPre = true;
    },
    deletePreautorizzatoHandler(oggetto) {
      this.eliminaPre = oggetto;
      this.newPre = false;
      this.dialog = true;
      this.deletePre = true;
    },
    salvaPreautorizzatoHandler() {
      //        console.log(this.newpreauto);
      this.$store.dispatch("gestione/salvaPreautorizzato", {
        ...this.newpreauto
      });
      this.newpreauto = {};
      this.dialog = false;
    },
    eliminaPreautorizzatoHandler(login) {
      this.$store.dispatch("gestione/eliminaPreautorizzato", {
        login: this.eliminaPre.login
      });
      this.eliminaPre = null;
      this.dialog = false;
      this.deletePre = false;
    },
    creaIcone(vettore) {
      return this.categorie
        .filter(ct => {
          return vettore && vettore.split(",").includes(ct.id);
        })
        // .map(ct => ct.icon);
    },
    chiudiHandler() {
      this.dialog = false;
      this.newPre = false;
      this.deletePre = false;
      this.newpreauto = {};
      this.eliminaPre = {};
    }
  }
};
</script>

<style lang="scss" scoped>
.v-list__tile--active {
  .v-icon {
    color: #01579b !important;
  }
}
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/components/Preautorizzato.vue